/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;
  var D1 = "----";
  var D2 = "----";
  var D3 = "----";
  var S1 = "----";
  var S2 = "----";
  var S3 = "----";
  var S4 = "----";
  var S5 = "----";
  var S6 = "----";
  var S7 = "----";
  var S8 = "----";
  var S9 = "----";
  var S10 = "----";
  var C1 = "----";
  var C2 = "----";
  var C3 = "----";
  var C4 = "----";
  var C5 = "----";
  var C6 = "----";
  var C7 = "----";
  var C8 = "----";
  var C9 = "----";
  var C10 = "----";

  var check = function check() {
    var date = new Date($(".select_date").val());
    var toDate = new Date();

    if (date > toDate) {
      $f7.dialog.alert("Please select previous date");
      return false;
    }

    $f7.views.main.router.navigate("/kiosk_result_sg/?select_date=" + $(".select_date").val(), {
      reloadCurrent: true
    });
  };

  var updatesg = function updatesg(data) {
    D1 = "----";
    D2 = "----";
    D3 = "----";
    S1 = "----";
    S2 = "----";
    S3 = "----";
    S4 = "----";
    S5 = "----";
    S6 = "----";
    S7 = "----";
    S8 = "----";
    S9 = "----";
    S10 = "----";
    C1 = "----";
    C2 = "----";
    C3 = "----";
    C4 = "----";
    C5 = "----";
    C6 = "----";
    C7 = "----";
    C8 = "----";
    C9 = "----";
    C10 = "----";
    $update();
    if (data == undefined) return;
    var obj = JSON.parse(data);
    obj = obj.results[0];
    D1 = obj.D1;
    D2 = obj.D2;
    D3 = obj.D3;
    S1 = obj.S1;
    S2 = obj.S2;
    S3 = obj.S3;
    S4 = obj.S4;
    S5 = obj.S5;
    S6 = obj.S6;
    S7 = obj.S7;
    S8 = obj.S8;
    S9 = obj.S9;
    S10 = obj.S10;
    C1 = obj.C1;
    C2 = obj.C2;
    C3 = obj.C3;
    C4 = obj.C4;
    C5 = obj.C5;
    C6 = obj.C6;
    C7 = obj.C7;
    C8 = obj.C8;
    C9 = obj.C9;
    C10 = obj.C10;
    $update();
  };

  var updateResult = function updateResult(page) {
    var select_date = page.route.query.select_date;
    var d = new Date();

    if (select_date) {
      d = new Date(select_date);
    } else {
      d = new Date(window.countdownsg);
      d.setDate(d.getDate() - 1);
    }

    var n = d.getDate();
    var m = d.getMonth() + 1;
    var y = d.getFullYear();
    var h = d.getHours();
    var day = ("0" + n).slice(-2);
    var month = ("0" + m).slice(-2);
    var today = y + "-" + month + "-" + day;
    var mTxt = "";

    switch (m) {
      case 1:
        mTxt = "Jan";
        break;

      case 2:
        mTxt = "Feb";
        break;

      case 3:
        mTxt = "Mar";
        break;

      case 4:
        mTxt = "Apr";
        break;

      case 5:
        mTxt = "May";
        break;

      case 6:
        mTxt = "Jun";
        break;

      case 7:
        mTxt = "Jul";
        break;

      case 8:
        mTxt = "Aug";
        break;

      case 9:
        mTxt = "Sep";
        break;

      case 10:
        mTxt = "Oct";
        break;

      case 11:
        mTxt = "Nov";
        break;

      case 12:
        mTxt = "Dec";
        break;
    }

    $(".select_date").val(today);
    $(".today-date").html(n + " " + mTxt + " " + y); //$f7.preloader.show();

    $f7.request({
      method: 'get',
      url: window.waypoint + 'result.aspx',
      data: {
        lang: window.lang,
        reqId: window.uuid,
        drawDate: today,
        drawType: 4
      },
      // beforeSend: function (xhr){
      //   xhr.setRequestHeader('Authorization', "Basic " + window.authbasic)
      // },
      success: function success(data) {
        console.log(data); //$f7.preloader.hide();

        var obj = JSON.parse(data);

        if (obj.status == "0") {} else {
          updatesg(data);
        }
      }
    });
  };

  $on('pageInit', function (e, page) {
    updateResult(page);
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="result">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner sliding">
        <div class="left">
          <a href="#" class="link back">
            <i class="icon icon-back"></i>
            <span class="if-not-md">
              <span class='en'>Back</span>
              <span class='cn'>返回</span>
              <span class='tl'>Fila</span>
            </span>
          </a>
        </div>
        <div class="title"><img src="static/images/sg.png" style="width:30px;vertical-align: middle;"/> 
          <span class='en'> SG Result</span>
          <span class='cn'> SG 成绩</span>
          <span class='tl'> SG Rejultadu</span>
        </div>
      </div>
    </div>

    <!-- Scrollable page content-->
    <div class="page-content">

      <div class="block">
        <div class="list inline-labels no-hairlines-md">
          <ul>
            <li class="item-content item-input">
              <div class="item-media">
                <i class="icon demo-list-icon"></i>
              </div>
              <div class="item-inner">
                <div class="item-title item-label">
                  
                    <span class='en'>Date</span>
                    <span class='cn'>日期</span>
                    <span class='tl'>Data</span>
                  
                </div>
                <div class="item-input-wrap">
                  <input type="date" class="select_date" placeholder="Please choose..." />
                </div>
              </div>
            </li>
          </ul>
        </div>


        <button class="button button-fill button-round" @click=${check}>
          
            
            <span class='cn'></span>
            <span class='tl'>DATA TROKA</span>
          
        </button>
      </div>      

      <!-- PRIZE RESULT -->
      <div class="card data-table" style="border-radius: 10px;">
        <table>
          <thead>
            <tr >
              <th colspan=2 class="label-cell" style="background-color: #8D4AED ; color: rgb(255, 245, 191); font-size: 20px;">
                  <span class='en'>4D Result</span>
                  <span class='cn'>4D 成绩</span>
                  <span class='tl'>4D Rejultadu</span>
              </th>
              <th class="text-align-right" style="background-color: #8D4AED;">
                <span class="today-date" style="font-size: 13px;font-weight: bold;color: rgb(255, 245, 191);">
                6 Feb 2021
              </span></th>
            </tr>
          </thead>
          <tbody class="text-align-center"> 
            <tr>
              <td class="label-cell tabular" width=33%><span style="font-size: 14px;">1</span><span style="font-size: 10px;">ST</span> <span>Prize</span></td>
              <td class="label-cell tabular" width=33%><span style="font-size: 14px;">2</span><span style="font-size: 10px;">ND</span> <span>Prize</span></td>
              <td class="label-cell tabular" width=33%><span style="font-size: 14px;">3</span><span style="font-size: 10px;">RD</span> <span>Prize</span></td>
            </tr>
            <tr> 
              <td class="" width=33%><span style="font-size:18px">${D1}</span></td>
              <td class="" width=33%><span style="font-size:18px">${D2}</span></td>
              <td class="" width=35%><span style="font-size:18px">${D3}</span></td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- SHOW FULL BEIGN -->
      <div class="show-full">
        <div class="card data-table" style="border-radius: 10px;">
          <table>
            <thead>
              <tr>
                <th colspan="3" class="label-cell text-align-center" style="background-color: #8D4AED; color: rgb(255, 245, 191); font-size: 14px; height: 20px;">
                  <span >SPECIAL PRIZE</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="numeric-cell text-align-center"><span style="font-size:18px">${S1}</span></td>
                <td class="numeric-cell text-align-center"><span style="font-size:18px">${S2}</span></td>
                <td class="numeric-cell text-align-center"><span style="font-size:18px">${S3}</span></td>
              </tr>
              <tr>
                <td class="numeric-cell text-align-center"><span style="font-size:18px">${S4}</span></td>
                <td class="numeric-cell text-align-center"><span style="font-size:18px">${S5}</span></td>
                <td class="numeric-cell text-align-center"><span style="font-size:18px">${S6}</span></td>
              </tr>
              <tr>
                <td class="numeric-cell text-align-center"><span style="font-size:18px">${S7}</span></td>
                <td class="numeric-cell text-align-center"><span style="font-size:18px">${S8}</span></td>
                <td class="numeric-cell text-align-center"><span style="font-size:18px">${S9}</span></td>
              </tr>
              <tr>
                <td colspan="3" class="numeric-cell text-align-center"><span style="font-size:18px">${S10}</span></td>
              </tr>
            </tbody>
          </table>  
        </div>
  
        <div class="card data-table" style="border-radius: 10px;">
          <table>
            <thead>
              <tr>
                <th colspan="3" class="label-cell text-align-center" style="background-color: #8D4AED; color: rgb(255, 245, 191); font-size: 14px; height: 20px;">
                  <span >CONSOLATION PRIZE</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="numeric-cell text-align-center"><span style="font-size:18px">${C1}</span></td>
                <td class="numeric-cell text-align-center"><span style="font-size:18px">${C2}</span></td>
                <td class="numeric-cell text-align-center"><span style="font-size:18px">${C3}</span></td>
              </tr>
              <tr>
                <td class="numeric-cell text-align-center"><span style="font-size:18px">${C4}</span></td>
                <td class="numeric-cell text-align-center"><span style="font-size:18px">${C5}</span></td>
                <td class="numeric-cell text-align-center"><span style="font-size:18px">${C6}</span></td>
              </tr>
              <tr>
                <td class="numeric-cell text-align-center"><span style="font-size:18px">${C7}</span></td>
                <td class="numeric-cell text-align-center"><span style="font-size:18px">${C8}</span></td>
                <td class="numeric-cell text-align-center"><span style="font-size:18px">${C9}</span></td>
              </tr>
              <tr>
                <td colspan="3" class="numeric-cell text-align-center"><span style="font-size:18px">${C10}</span></td>
              </tr>
            </tbody>
          </table>  
        </div>      
      </div>
      <!-- SHOW FULL END -->

    </div>
  </div>
`
    }
    ;
}

framework7Component.id = 'a78f91a189';
export default framework7Component;